import { FC } from 'react';
import PortalToTarget from '../PortalToTarget';
import classNames from 'classnames';

type MobileModalProps = {
  renderHeaderComponent: JSX.Element | string;
  renderContentComponent: React.ReactNode | JSX.Element;
  renderFooterComponent: React.ReactNode | JSX.Element | string;
  isOpen: boolean;
  className?: string;
};

const MobileModal: FC<MobileModalProps> = (props) => {
  const { renderFooterComponent, renderHeaderComponent, renderContentComponent, isOpen, className } = props;

  if (!isOpen) return null;

  const combinedClassName = classNames('mobile-modal__wrapper', className, {
    open: isOpen,
  });

  return (
    <PortalToTarget className="mobile-modal">
      <div className={combinedClassName}>
        {renderHeaderComponent && <div className="mobile-modal__header">{renderHeaderComponent}</div>}
        {renderContentComponent && <div className="mobile-modal__content">{renderContentComponent}</div>}
        {renderFooterComponent && <div className="mobile-modal__footer">{renderFooterComponent}</div>}
      </div>
    </PortalToTarget>
  );
};

export default MobileModal;
